import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RoleJobDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RoleJobEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleJob/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RoleJobFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public roleId: IFieldOptions = { field: "roleId" };
	public jobId: IFieldOptions = { field: "jobId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.jobId);
	}
}

export class RoleJobForm implements IFormOptions {
	protected roleJobFormName: string = "roleJobForm";
	protected roleJobFormModel: models.RoleJobDTO = new models.RoleJobDTO();
	protected roleJobFormEndPoints: RoleJobEndPoints = new RoleJobEndPoints();
	protected roleJobFormFields: RoleJobFormFields = new RoleJobFormFields();
	public get name(): string { return this.roleJobFormName };
	public get model(): models.RoleJobDTO { return this.roleJobFormModel };
	public get endPoints(): IEntityEndPoints { return this.roleJobFormEndPoints };
       public set endPoints(roleJobEndPoints: IEntityEndPoints) {
		this.roleJobFormEndPoints = roleJobEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RoleJobFormFields { return this.roleJobFormFields };
}

export class RoleJobListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public roleId: IColumnOptions = { field: "roleId" };
	public jobId: IColumnOptions = { field: "jobId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.jobId);
	}
}

export class RoleJobList implements IGridOptions {
	protected roleJobListName: string = "roleJobList";
	protected roleJobListModel: models.RoleJobDTO = new models.RoleJobDTO();
	protected roleJobListEndPoints: RoleJobEndPoints = new RoleJobEndPoints();
	protected roleJobListColumns: RoleJobListColumns = new RoleJobListColumns();
	public roleJobForm: RoleJobForm = new RoleJobForm();
	public get name(): string { return this.roleJobListName };
	public get model(): models.RoleJobDTO { return this.roleJobListModel };
	public get endPoints(): IEntityEndPoints { return this.roleJobListEndPoints };
	public set endPoints(roleJobEndPoints: IEntityEndPoints) {
		this.roleJobListEndPoints = roleJobEndPoints;
		this.roleJobForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RoleJobListColumns { return this.roleJobListColumns };
}

export class RoleJobEntity implements IEntityOptions {
	protected roleJobEntityName: string = "roleJobEntity";
	protected roleJobEntityModel: models.RoleJobDTO = new models.RoleJobDTO();
	protected roleJobEntityEndPoints: RoleJobEndPoints = new RoleJobEndPoints();
	protected roleJobEntityList: RoleJobList = new RoleJobList();
	public get name(): string { return this.roleJobEntityName };
	public get model(): models.RoleJobDTO { return this.roleJobEntityModel };
	public get endPoints(): IEntityEndPoints { return this.roleJobEntityEndPoints };
	public set endPoints(roleJobEndPoints: IEntityEndPoints) {
		this.roleJobEntityEndPoints = roleJobEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RoleJobList { return this.roleJobEntityList };
	public get form(): RoleJobForm { return this.grid.roleJobForm };
	constructor(name?: string) {
		if (name) this.roleJobEntityName = name;
		this.endPoints = this.roleJobEntityEndPoints;
	}
};
//export class RoleJobGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RoleJobForm = new RoleJobForm();
//};

//export class RoleJobListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RoleJobList = new  RoleJobList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RoleJobBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleJobGeneratedForm}];
//};

//export class RoleJobListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleJobListPageComponent, isMenuHidden: true }];
//};

